import type * as Types from 'connect-graphql/generated';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AuthenticatedUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AuthenticatedUserQuery = { __typename?: 'Query', authenticatedUser: { __typename?: 'AuthenticatedUser', id: string, email: string, firstName: string, lastName: string, inactive: boolean, organizationRoles: Array<{ __typename?: 'OrganizationRole', id: string, role: Types.AppRole, cleared?: boolean | null, organization: { __typename?: 'Organization', id: string, name: string, type: Types.OrganizationType } }>, selectedOrganizationRole: { __typename?: 'OrganizationRole', id: string, role: Types.AppRole, cleared?: boolean | null, organization: { __typename?: 'Organization', id: string, name: string, type: Types.OrganizationType } } } };


export const AuthenticatedUserDocument = gql`
    query AuthenticatedUser {
  authenticatedUser {
    id
    email
    firstName
    lastName
    inactive
    organizationRoles {
      id
      role
      cleared
      organization {
        id
        name
        type
      }
    }
    selectedOrganizationRole {
      id
      role
      cleared
      organization {
        id
        name
        type
      }
    }
  }
}
    `;

export function useAuthenticatedUserQuery(options?: Omit<Urql.UseQueryArgs<AuthenticatedUserQueryVariables>, 'query'>) {
  return Urql.useQuery<AuthenticatedUserQuery, AuthenticatedUserQueryVariables>({ query: AuthenticatedUserDocument, ...options });
};